import { Component, computed, input } from '@angular/core';
import { ClassValue } from 'clsx';
import { bui } from '../utils';

@Component({
  selector: 'alert-dialog-description',
  host: {
    '[class]': 'computedClass()',
  },
  template: `<ng-content />`,
})
export class AlertDialogDescription {
  // Inputs / Outputs
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  // State
  protected readonly computedClass = computed(() =>
    bui(
      // Base
      'text-neutral-a11',

      // User classes
      this.userClass(),
    ),
  );
}
